export { default } from '../TablesPage';
